import {
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Box,
  Button,
  Divider,
} from "@mui/material";
import IosShareIcon from "@mui/icons-material/IosShare";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useNavigate } from "react-router-dom";

export const AddToHomeScreenIos = () => {
  const navigate = useNavigate();
  return (
    <>
      <Box sx={{ p: 1 }}>
        <Button onClick={() => navigate("/")}>
          <ArrowBackIosIcon fontSize="small" />
          戻る
        </Button>
      </Box>
      <Divider />
      <Card
        sx={{
          maxWidth: 600,
          margin: "auto",
          mt: 2,
          mx: 1,
          p: 1,
          borderRadius: 4,
          boxShadow: 3,
        }}
      >
        <CardContent>
          <Typography variant="h5" gutterBottom>
            iOSでダウンロードする方法
          </Typography>
          <Typography variant="body1" gutterBottom>
            iPhone や iPad
            でアプリをダウンロードするには、以下の手順を行ってください。
          </Typography>
          <List>
            <ListItem>
              <ListItemText primary="1. Safariでこのページを開きます" />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={
                  <Box display="flex" alignItems="center">
                    <Typography variant="body1" component="span">
                      2. 下部中央の「共有」アイコン
                      <IosShareIcon fontSize="small" />
                      をタップします
                    </Typography>

                    <Typography variant="body1" component="span"></Typography>
                  </Box>
                }
              />
            </ListItem>
            <ListItem>
              <ListItemText primary="3. メニューの中から『ホーム画面に追加』を選択します" />
            </ListItem>
            <ListItem>
              <ListItemText primary="4. 名前を確認して『追加』をタップします" />
            </ListItem>
          </List>
          <Typography variant="body2" color="text.secondary" mt={2}>
            ※
            Safari以外のブラウザ（ChromeやFirefox）ではこの機能は利用できません。
          </Typography>
        </CardContent>
      </Card>
    </>
  );
};
